import { FrameworkConfiguration, PLATFORM } from 'aurelia-framework';
import { RouteGenerator } from '@rightship-tech/common-ui/route-generator';

//Load styles
require("@rightship-tech/due-diligence-app/styles/core.scss");

export function configure(config: FrameworkConfiguration) {

    //Aurelia plugins
    // config.plugin(PLATFORM.moduleName('aurelia-validation')); 
    // config.plugin(PLATFORM.moduleName('aurelia-ui-virtualization')); 

    //Load global resources
    config.globalResources([
       
        //Components
        PLATFORM.moduleName("./views/components/comp-due-diligence-status-card/comp-due-diligence-status-card"),
       
        //Partials
        PLATFORM.moduleName("./views/partials/due-diligence-widget/partial-due-diligence-widget")
    ]);

    //Load plugins
    config.plugin(PLATFORM.moduleName("@rightship-tech/common-ui"));
    
    //Generate routes
    const routeGenerator: RouteGenerator = config.container.get(RouteGenerator);
    const routes = [
    ];

    //Set routes
    for (var route of routes) {
        routeGenerator.addRoute(route);
    }
}